module.exports = "pegasus/assets/blocks/social-1-theme4.png";